<attrs/{ getCompilerOptions, files }/>
<let/selectedIndex = 0/>
<let/previewType = "preview"/>
<let/debounce = false/>
<const/selectedFile = files[selectedIndex]/>

<style>
  .editor-container {
    background: #202134;
    color: #fff;
  }
</style>

<resizable-panes>
  <@left class="editor-container">
    <pane>
      <@actions>
        <file-tabs base=getCompilerOptions?.()?.translator ? "tags" : "components" files:=files selectedIndex:=selectedIndex/>
      </@actions>
      <@body>
        <let/activeEditor = null/>
        <if=activeEditor>
          <activeEditor
            value=selectedFile.content 
            filename=selectedFile.path 
            valueChange(content) {
              const modifiedFile = { ...selectedFile, content };
              files = [
                ...files.slice(0, selectedIndex), 
                modifiedFile,
                ...files.slice(selectedIndex+1)
              ];
              debounce = true;
            }/>
        </if>
        <lifecycle onMount = (async () => { 
          const e = await import("./components/editor");
          await e.loading;
          activeEditor = e;
        })/>
      </@body>
    </pane>
  </@left>
  <@right>
    <pane>
      <@actions>
        <controllable-select.preview-select 
          value=previewType 
          valueChange(value) {
            previewType = value;
            debounce = false;
          }>
          <option value="preview">App Preview</option>
          <option value="compiled-html">Compiled (HTML)</option>
          <option value="compiled-vdom">Compiled (DOM)</option>
        </controllable-select>
        <playground-link files=files/>
        <style>
          .preview-select {
            border:0;
            height:100%;
            font-size: 100%;
            padding:0 1em;
          }
        </style>
      </@actions>
      <@body>
        <let/preview = null/>
        <${preview} 
          type=previewType
          files=files
          selectedFile=selectedFile
          getCompilerOptions=getCompilerOptions
          debounce=debounce/>
        <lifecycle onMount = (async () => { 
          preview = await import("./components/preview");
        })/>
      </@body>
    </pane>
  </@right>
</resizable-panes>